import type { ButtonProps } from '@hover/blueprint';
import { iconSaveFilled, iconSaveOutlined } from '@hover/icons';
import React from 'react';

import { useReferringProject } from 'src/modules/homeownerApp/components/Customize/useReferringProject';
import { Button } from 'src/shared/components';
import type { AiDisplayImageFragment } from 'src/shared/graphql/generated';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import { useSaveToProject } from '../../hooks';

export interface SaveButtonProps extends Omit<ButtonProps, 'icon' | 'label'> {
  image?: AiDisplayImageFragment;
  colorScheme: 'dark' | 'light';
  sx?: object;
}

export const SaveButton = ({
  image,
  colorScheme = 'light',
  ...props
}: SaveButtonProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { referreringProject } = useReferringProject();

  const { isSavedToProject, handleSave } = useSaveToProject({
    image,
    // TODO: update this per the projects tracking plan
    location: 'thumbnail',
    referreringProject,
  });

  if (!image) return null;

  return (
    <Button
      colorScheme={colorScheme}
      icon={isSavedToProject ? iconSaveFilled : iconSaveOutlined}
      label={t('projects.save')}
      onClick={handleSave}
      variant="ghost"
      {...props}
    />
  );
};
